module.exports = __webpack_public_path__ + "img/B3.bbe2c47e.svg";